import ZLink from './ZLink.vue'

export default ZLink
